import request from './axios';

/**
 * 获取产品列表
 * @returns {Promise<Object>} 返回产品列表
 */
export function getProductList() {
  return request({
    url: '/webapi/product/list',
    method: 'get'
  });
}

/**
 * 获取产品详情
 * @param {String} id 产品ID
 * @returns {Promise<Object>} 返回产品详情
 */
export function getProductDetail(id) {
  return request({
    url: `/webapi/product/detail/${id}`,
    method: 'get'
  });
} 